import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/who5";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllWho5ByTax(params.tratamientoId);
}

export function Who5List(props) {
  const [who5List, setWho5] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllWho5ByTax(props.id).then(setWho5).catch(console.log);
  }, [props.id]);
  return (
    <>
      {who5List?.length ? (
        <ul className='who5 cpt-list'>
          {who5List
            .sort((a, b) => {
              // Convertir las fechas a objetos de fecha para comparar
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Ordenar de manera descendente (más reciente primero)
              return dateB - dateA;
            })
            .map((who5) => (
              <li key={who5.id}>
                <NavLink
                  to={`${props.id}/cuestionarios/who5/${who5.id}`}
                >
                  {`${FormatDate(who5.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

      ) : (
        <></>
      )}
    </>
  );
}

export function Who5ListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id='content'>
        <h1>Who5</h1>
      </div>
      <div id='actions'>
        {
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
        }
      </div>
    </>
  );
}
